import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3516">
      <Navbar data-id="element-3517" />
      <main data-id="element-3518">
        <ConsularAffairs data-id="element-3519" />
      </main>
      <Footer data-id="element-3520" />
      <FeedbackPopup data-id="element-3521" />
    </div>;
}